export default __webpack_public_path__ + "static/media/drink5.fbc906bc.jpg";